import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import heroImg from '../asets/bg2.jpg';  // Correct your hero image path accordingly
import NoticeBoard from './NoticeBoard';
import Location from './Location';
import { Cardsir } from './CardSir';
import Center from './Center';
import './Header.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

// Import alumni images from assets folder
import nandiniImg from '../asets/AlumniPhoto/Nandini.jpg';
import kuldeepImg from '../asets/AlumniPhoto/Kuldeep.jpg';
import vaibhaviImg from '../asets/AlumniPhoto/Vaibhavi.jpg';
import ratneshImg from '../asets/AlumniPhoto/Ratnesh.jpg';
import anshulImg from '../asets/AlumniPhoto/Anshul.jpg';
import rohanImg from '../asets/AlumniPhoto/Rohan.jpg';

const Header = () => {
  useEffect(() => {
    const counters = document.querySelectorAll('.counter');
    counters.forEach(counter => {
      counter.innerText = '0';
      const updateCounter = () => {
        const target = +counter.getAttribute('data-target');
        const count = +counter.innerText;
        const increment = target / 200;
        if (count < target) {
          counter.innerText = `${Math.ceil(count + increment)}`;
          setTimeout(updateCounter, 10);
        } else {
          counter.innerText = target;
        }
      };
      updateCounter();
    });
  }, []);

  return (
    <div className="header-container">
      <Helmet>
        <title>Sahaj Public School - Raise Yourself to Help Mankind</title>
        <meta name="description" content="Sahaj Public School - Excellence in education with strong moral values and holistic development." />
        <meta name="keywords" content="school, education, Sahaj Public School, holistic development, moral values" />
        <meta name="author" content="Sahaj Public School" />
      </Helmet>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-text">
          <h1 className="animate-fadeInDown">Sahaj Public School</h1>
          <p className="animate-fadeInUp">Raise Yourself to Help Mankind</p>
          <button className="hero-btn animate-fadeInUp">Explore More</button>
        </div>
        <div className="hero-img">
          <img src={heroImg} alt="School Building" />
          <div className="shapes"></div>
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="vision-mission">
        <h2>Our Vision</h2>
        <p>To develop compassionate individuals with a strong academic foundation and moral values.</p>
        <h2>Our Mission</h2>
        <p>To empower students to achieve excellence through holistic education, creativity, and discipline.</p>
      </section>

      {/* Counters */}
      <section className="counters-section">
        <div className="counter-box">
          <h3><span className="counter" data-target="1200">0</span>+</h3>
          <p>Students</p>
        </div>
        <div className="counter-box">
          <h3><span className="counter" data-target="50">0</span>+</h3>
          <p>Teachers</p>
        </div>
        <div className="counter-box">
          <h3><span className="counter" data-target="25">0</span>+</h3>
          <p>Awards</p>
        </div>
      </section>

      {/* Alumni Section */}
      <section className="alumni-section">
        <h2>Meet Our Proud Alumni</h2>
        <p>Our students have gone on to achieve greatness in various fields around the world.</p>
        <div className="alumni-cards">
          {[
            { name: 'Dr. Nandini Maheshwari', role: 'MBBS', image: nandiniImg, gradient: '#667eea, #764ba2' },
            { name: 'Kuldeep Chawada', role: 'Para Commando (Army)', image: kuldeepImg, gradient: '#f6d365, #fda085' },
            { name: 'Dr. Vaibhavi Chamlate', role: 'MBBS', image: vaibhaviImg, gradient: '#43cea2, #185a9d' },
            { name: 'Ratnesh Vijayvargiya', role: 'Software Engineer', image: ratneshImg, gradient: '#ff9a9e, #fecfef' },
            { name: 'Anshul Jain', role: 'Foreign Ministry', image: anshulImg, gradient: '#a1c4fd, #c2e9fb' },
            { name: 'Rohan Naveen', role: 'Malkham - National "Khelo India"', image: rohanImg, gradient: '#f7971e, #ffd200' }
          ].map((alumni, index) => (
            <div
              className="alumni-card"
              key={index}
              style={{ background: `linear-gradient(135deg, ${alumni.gradient})` }}
            >
              <img src={alumni.image} alt={alumni.name} />
              <h4>{alumni.name}</h4>
              <p>{alumni.role}</p>
            </div>
          ))}
        </div>
      </section>

      {/* About School */}
      <section className="about-school">
        <h2>Why Sahaj Public School?</h2>
        <ul>
          <li>CBSE-affiliated curriculum</li>
          <li>Experienced and caring faculty</li>
          <li>Modern classrooms with smart boards</li>
          <li>Focus on moral values and discipline</li>
          <li>Holistic development: academics, sports, and arts</li>
        </ul>
      </section>

      {/* Student Reviews */}
      <section className="testimonials">
        <h2>What Students Say</h2>
        <div className="testimonial-slider">
          <div className="testimonial">
            <p>"Best school ever! I learned not just academics, but life values."</p>
            <h5>- Aditi Soni (Class 12)</h5>
          </div>
          <div className="testimonial">
            <p>"The teachers are very supportive and always ready to help."</p>
            <h5>- Sahil Medhe (Class 12)</h5>
          </div>
        </div>
      </section>

      {/* Quick Facts */}
      <section className="quick-facts">
        <div className="fact">
          <i className="fas fa-book-reader"></i>
          <h3>100%</h3>
          <p>Board Exam Results</p>
        </div>
        <div className="fact">
          <i className="fas fa-chalkboard-teacher"></i>
          <h3>30+</h3>
          <p>Smart Classrooms</p>
        </div>
        <div className="fact">
          <i className="fas fa-award"></i>
          <h3>25+</h3>
          <p>Awards Won</p>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-enroll">
        <h2>Join Sahaj Public School Today</h2>
        <p>Admissions open for the academic year 2025–2026.</p>
        <button className="enroll-btn">Apply Now</button>
      </section>

      <Cardsir />
      <Center />
      <NoticeBoard />
      <Location />
    </div>
  );
};

export default Header;
